import axios from "../axios";
import {request} from "../../../mock/request";

export default {
    getNewsList(inOpts) {
        return axios.request({
            cmd:'dynamicApi/dynamicAllList',
            data:inOpts,
        })
    },
    getCompanyDynamics(inOpts){
        return axios.request({
            cmd:'dynamicApi/dynamicList',
            data:inOpts,
        })
    },
    getNewsDetail(inOpts){
        return axios.request({
            cmd:'dynamicApi/getDynamicById',
            data:inOpts,
        })
    },

}